import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
export class FormlyFieldRadio extends FieldType {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-field-radio',
  template: `
    <div [formGroup]="form">
      <div *ngFor="let option of to.options" class="radio">
        <label class="custom-control custom-radio">
          <input [name]="id" type="radio" [value]="option.key" [formControl]="formControl"
          [formlyAttributes]="field" class="custom-control-input">
          {{ option.value }}
          <span class="custom-control-indicator"></span>
        </label>
      </div>
    </div>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormlyFieldRadio_tsickle_Closure_declarations() {
/** @type {?} */
FormlyFieldRadio.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyFieldRadio.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
